import {useSearchParams} from "react-router-dom";

export const useQueryParam = (key) => {
    let [searchParams] = useSearchParams();
    return searchParams.get(key);
}
